import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import SectionAd from './SectionAd';

const DOUBLE_AD_PATTERNS = [
  '/ranking',
  '/shows/:id/edit-show'
];

const matchesRoute = (pathname, pattern) => (
  Boolean(matchPath({ path: pattern, end: true }, pathname))
);

export default function RouteBottomAds() {
  const { pathname } = useLocation();
  const adCount = DOUBLE_AD_PATTERNS.some((pattern) => matchesRoute(pathname, pattern)) ? 2 : 1;

  return (
    <div className="container pb-4">
      {Array.from({ length: adCount }).map((_, index) => (
        <SectionAd
          key={`${pathname}-adsGen1-${index}`}
          placement="adsGen1"
          className={`d-flex justify-content-center ${index === 0 ? 'mt-4 mb-3' : 'mt-0 mb-3'}`}
        />
      ))}
    </div>
  );
}
